// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coach-info-box[data-v-2c334843]{border:1px solid #1c75d466;font-family:var(--babri-font-primary,\"Proxima Nova\"),sans-serif;color:#000}.profile-image[data-v-2c334843]{width:100px;height:100px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
